import APIService from 'services/APIService'
import {
  getSrqDiagnosticsApiParams,
  SrqDiagnosticsApiParams
} from 'modules/quizDiagnostics/utils/getSrqApiParams'

const api = APIService()

export const fetchEvaluationInfo = () => api.get(`/ai-tutor-scores/average`)

export const fetchChapterSubchapters = (
  payload: { id: string },
  params: SrqDiagnosticsApiParams = getSrqDiagnosticsApiParams()
) =>
  api.get(`/student-book-chapters/${payload.id}/subchapters`, { params })
